// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2h83I","left":"StickyBox_left__2uWE2","right":"StickyBox_right__1Gh-F"};